import { CommonModule, NgFor } from '@angular/common';
import { Component, inject, Input, OnChanges, Output, SimpleChanges, EventEmitter, input } from '@angular/core';
import { ITicket } from '../../../models/ITicket';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TicketService } from '../../../services/tickets/ticket.service';
import { SanitizeHtmlTextPipe } from '../../../shared/pipes/sanitize-html-text.pipe';
import { DefaultImageComponent } from "../default-image/default-image.component";
import { ThemeService } from '../../../services/theme.service';
import { AbsoluteMediaUriService } from '../../../services/absolute-media-uri.service';



@Component({
  selector: 'app-tickets',
  imports: [CommonModule,
    NgFor,
    ButtonModule,
    FormsModule,
    RouterModule,
    SanitizeHtmlTextPipe, DefaultImageComponent],
  templateUrl: './tickets.component.html',
  styleUrl: './tickets.component.scss'
})
export class TicketsComponent implements OnChanges {

  @Input() tickets: ITicket[] = [];
  @Input() isHomePage: boolean | null = null;
  @Input() id!: number;
  public auctionId = input(0);
  showDivTickets: boolean = false;
  descriptionExpanded: boolean = false;
  @Output() quantityChanged = new EventEmitter<ITicket[]>();


  private readonly ticketService = inject(TicketService);
  protected readonly themeService = inject(ThemeService);
  private readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  ticketEventSignal = this.ticketService.ticketEventSignal;

  constructor() {
  }


  ngOnChanges(changes: SimpleChanges): void {


    if (changes['tickets'] && changes['tickets'].currentValue?.length > 0) {
      const newTickets: ITicket[] = changes['tickets'].currentValue;

      this.tickets = newTickets.map(t => ({
        ...t,
        quantitySelected: t.quantitySelected ?? 0,
        imageUrl: t.imageUrl && t.imageUrl.trim()
          ? this.absoluteMediaUriService.getAbsoluteMediaUri(t.imageUrl)
          : '/ticket-default.jpg',
      }));

      this.showDivTickets = true;

    }

  }

  ngOnInit(): void {
    this.themeService.calculateIsCustomizedTheme(this.id);
  }
  onQuantityChange(): void {
    const selected = this.tickets.filter(t => (t.quantitySelected || 0) > 0);
    this.quantityChanged.emit(selected);
  }

  decrease(ticket: ITicket) {

    if (!ticket.quantitySelected || ticket.quantitySelected <= 0) {
      return;
    }

    if (ticket.quantitySelected <= ticket.minPerOrder) {
      ticket.quantitySelected = 0;
      this.onQuantityChange();
      return;
    }

    let realMin;
    if (ticket.quantityAvailable < ticket.minPerOrder) {
      realMin = ticket.quantityAvailable;
    } else {
      realMin = ticket.minPerOrder;
    }

    if (ticket.quantitySelected > realMin) {
      ticket.quantitySelected--;
      this.onQuantityChange();
    }
  }

  increase(ticket: ITicket) {

    if (ticket.quantityAvailable <= 0) {
      ticket.quantitySelected = 0;
      return;
    }

    let realMin;
    if (ticket.quantityAvailable < ticket.minPerOrder) {
      realMin = ticket.quantityAvailable;
    } else {
      realMin = ticket.minPerOrder;
    }


    let realMax;
    if (ticket.quantityAvailable < ticket.maxPerOrder) {
      realMax = ticket.quantityAvailable;
    } else {
      realMax = ticket.maxPerOrder;
    }


    if (!ticket.quantitySelected || ticket.quantitySelected === 0) {
      ticket.quantitySelected = realMin;
    }
    else if (ticket.quantitySelected < realMax) {
      ticket.quantitySelected++;
    }

    this.onQuantityChange();
  }


  enforceMax(event: any, ticket: ITicket) {

    const rawValue = event.target.value;
    if (rawValue === '') return;

    let value = Number(rawValue);
    if (isNaN(value)) return;

    let realMax;

    if (ticket.quantityAvailable < ticket.maxPerOrder) {
      realMax = ticket.quantityAvailable;
    } else {
      realMax = ticket.maxPerOrder;
    }

    if (value > realMax) {
      ticket.quantitySelected = realMax;
      event.target.value = realMax;
    } else {
      ticket.quantitySelected = value;
    }

    this.onQuantityChange();
  }

  enforceMin(ticket: ITicket) {

    if (ticket.quantitySelected == null) return;

    let realMin;

    if (ticket.quantityAvailable < ticket.minPerOrder) {
      realMin = ticket.quantityAvailable;
    } else {
      realMin = ticket.minPerOrder;
    }

    if (ticket.quantitySelected < realMin) {
      ticket.quantitySelected = realMin;
    }


    this.onQuantityChange();
  }



  onRemove(ticket: ITicket) {
    ticket.quantitySelected = 0;
    this.onQuantityChange();
  }

  trackById(index: number, ticket: ITicket) {
    return ticket.id;
  }

  toggleExpand() {
    this.descriptionExpanded = !this.descriptionExpanded
  }

}



